import { CpOrderInvoicesListPageState } from './cp_order_invoices_list_types';

// PAGE STORE
export function cpOrderInvoicesListPageStateVM(): CpOrderInvoicesListPageState {
    return {
        init: false,
        canEdit: false,
        loading: false,
        action: '',
        userType: '',
        userAffList: [],
        userImpersonate: false,
    };
}
